import React from 'react';
import StyledCustomLabelWrapper from '../../../../../style/Common/Controller/Common/Custom/StyledCustomLabelWrapper';
import StyledCustomLabelRequiredWrapper from '../../../../../style/Common/Controller/Common/Custom/StyledCustomLabelRequiredWrapper';
import StyledCustomLabelTextWrapper from '../../../../../style/Common/Controller/Common/Custom/StyledCustomLabelTextWrapper';

const ControllerLabel = ({
  label,
  required,
  suppressLabelVisible,
  suppressLabelContentVisible,
  styles,
}) => {
  return (
    !suppressLabelVisible && (
      <StyledCustomLabelWrapper $styles={styles}>
        {!suppressLabelContentVisible && (
          <>
            {required && label && (
              <StyledCustomLabelRequiredWrapper>
                *
              </StyledCustomLabelRequiredWrapper>
            )}
            <StyledCustomLabelTextWrapper $styles={styles}>
              {label}
            </StyledCustomLabelTextWrapper>
          </>
        )}
      </StyledCustomLabelWrapper>
    )
  );
};

export default ControllerLabel;
